import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

const ListHeader = ({
    title = "List",
    searchQuery,
    handleSearch,
    handleSearchChange,
    viewMode,
    handleViewModeChange, // Updated prop
    handleOpenCreateModal,
    children,

}) => {
    return (
        <div className="flex justify-between items-center mb-4 p-4">
            <h2 className="text-2xl font-bold">{title}</h2>
            <div className="flex justify-end gap-4">


                {/* Search Input */}


                <div
                    className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                    <button
                        onClick={handleSearch}
                        className="px-3 py-2 text-gray-500 cursor-pointer border-r border-gray-300 bg-gray-50 hover:bg-gray-100 hover:text-sss-blue duration-500">
                        <SearchIcon />
                    </button>
                    <input
                        type="text"
                        className="px-3 py-2 w-full outline-none"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                </div>


                {children}

                {/* Add Employee Button */}
                <div>
                    <button
                        className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
                        onClick={handleOpenCreateModal}
                    >
                        Add +
                    </button>
                </div>

                {/* View Mode Toggle Dropdown */}
                <select
                    value={viewMode}
                    onChange={(e) => handleViewModeChange(e.target.value)}
                    className="px-2 py-2 border-2 border-sss-blue rounded-lg focus:border-sss-blue text-sss-blue-sel font-bold focus:outline-none"
                >
                    <option value="table">Table View</option>
                    <option value="card">Card View</option>
                </select>
            </div>
        </div>
    );
};

export default ListHeader;
